import React from 'react';
import CheckRadioBase from './CheckRadioBase';
import PropTypes from 'prop-types';
import './Checkbox.less';

function Checkbox(props) {
    return <CheckRadioBase type="checkbox" {...props} />;
}

Checkbox.propTypes = {
    /** Mark the Checkbox as indeterminate */
    indeterminate: PropTypes.bool,
    ...CheckRadioBase.propTypes
};

Checkbox.defaultProps = {
    indeterminate: false,
    ...CheckRadioBase.defaultProps
};

export default Checkbox;
